import { Extension } from "@tiptap/core";

declare module "@tiptap/core" {
    interface Commands<ReturnType> {
        lineHeight: {
            /**
             * Set the line height
             * @param lineHeight The line height
             * @example editor.commands.setLineHeight('16px')
             */
            setLineHeight: (lineHeight: string) => ReturnType;
            /**
             * Unset the line height
             * @example editor.commands.unsetLineHeight()
             */
            unsetLineHeight: () => ReturnType;
        };
    }
}

export const LineHeight = Extension.create({
    name: "lineHeight",
    addOptions() {
        return {
            types: ["textStyle", "paragraph", "heading"],
        };
    },
    addGlobalAttributes() {
        return [
            {
                types: this.options.types,
                attributes: {
                    lineHeight: {
                        parseHTML: (element) => element.style.lineHeight,
                        renderHTML: (attributes) => {
                            if (!attributes.lineHeight) {
                                return {};
                            }
                            return {
                                style: `line-height: ${attributes.lineHeight};`,
                            };
                        },
                    },
                },
            },
        ];
    },
    addCommands() {
        return {
            setLineHeight:
                (lineHeight) =>
                ({ chain }) => {
                    return chain().setMark("textStyle", { lineHeight }).run();
                },
            unsetLineHeight:
                () =>
                ({ chain }) => {
                    return chain()
                        .setMark("textStyle", { lineHeight: null })
                        .removeEmptyTextStyle()
                        .run();
                },
        };
    },
});
